import { mapGetters, mapActions } from 'vuex'
import { Device } from '@/services/device'
// import { Logger } from '@/services/logger'
import moment from '@/utils/moment'

export default {
  data() {
    return {
      prev: '<< Previous',
      next: 'Next >>',
      isNewFeedback: false,
      loadingFeedback: false,
      // Reason model schema
      feedback: {
        code: false,
        code_severity: '',
        notes: '',
        alert_id: '',
        submitted_by: '',
        submitted_on: '',
        custom_reason: ''
      }
    }
  },
  computed: {
    ...mapGetters(['feedbackReasons']),
    ...mapGetters('device', ['device', 'currentDeviceId', 'submittedFeedbacks']),
    ...mapGetters('common/user', ['userId']),
    getFeedbackReasonOptions() {
      return this.feedbackReasons.map(reason => ({ label: reason.reason, value: reason.reason }))
    }
  },
  mounted() {
    if (!this.feedbackReasons.length) {
      this.fetchFeedbackReasons()
    }
  },
  methods: {
    ...mapActions({ setToast: 'setSingleProperty' }),
    ...mapActions(['fetchFeedbackReasons']),
    ...mapActions('device', ['fetchDeviceDetails']),
    /**
     * @method onAccuracy
     * updates accuracy
    */
    onAccuracy({ checked }) {
      this.feedback.accurate = checked
    },
    setFeedback(feedback) {
      this.feedback = Object.assign({}, this.feedback, feedback)
    },
    // Add new feedback start time and endtime
    onBrushEnd(e) {
      this.resetFeedback()
      this.isNewFeedback = true
      const startTime = new Date(e.startTime).getTime() / 1000
      const endTime = new Date(e.endTime).getTime() / 1000
      this.feedback = {
        ...this.feedback,
        startTime,
        endTime,
        deviceId: this.$route?.params?.id || this.currentDeviceId
      }
    },
    // Get Already Submitted Feedback
    onAreaClicked(data) {
      this.isNewFeedback = false
      this.feedback = { ...this.feedback, ...data }
    },
    /**
     * @method submitFeedback
     * Creates a feedback for alert
    */
    async submitFeedback() {
      if (this.loadingFeedback) return // just to make sure, not to click multiple times
      try {
        this.feedback.submitted_by = this.userId
        this.feedback.submitted_on = new Date().toISOString()
        if (!this.isNewFeedback) {
          this.loadingFeedback = true
          await Device.updateFeedback(this.feedback)
        } else {
          const isValidFeedback = !this.submittedFeedbacks.some(({ startTime, endTime }) => {
            if (startTime === endTime) {
              return (this.feedback.startTime < startTime && this.feedback.endTime > endTime) && ((this.feedback.startTime > startTime && this.feedback.endTime > endTime) || (this.feedback.startTime < startTime && this.feedback.endTime < endTime))
            } else {
              return (this.feedback.startTime >= startTime) && (this.feedback.endTime <= endTime)
            }
          })
          if (isValidFeedback) {
            this.loadingFeedback = true
            const maxRangeDate = moment.formatDate(moment.dateSubtract(new Date(), 2, 'day'))
            const feedbackEndDate = moment.formatDate(moment.dateSubtract(new Date(this.feedback.endTime * 1000), 2, 'day'))
            await Device.createFeedback(this.feedback)
            if (maxRangeDate >= feedbackEndDate) {
              await Device.updateFeedbackStatus(this.Device.id)
            }
            this.setToast(['toast', { duration: 3000, show: true, message: 'Feedback is Created Successfully.' }])
            await this.fetchDeviceDetails({ id: this.feedback.deviceId })
          } else {
            this.setToast(['toast', { duration: 3000, show: true, color: '#F44336', message: 'A Feedback Already Exists for Selected Range.' }])
          }
          this.loadingFeedback = false
          return isValidFeedback
        }
      } catch (err) {
        this.setToast(['toast', {
          duration: 3000,
          show: true,
          message: err.message || err.error.message || 'There was a error while creating feedback. Please try again',
          color: '#F44336'
        }])
        this.loadingFeedback = false
      }
    },
    resetFeedback() {
      this.isNewFeedback = false
      this.feedback = {
        code: false,
        code_severity: '',
        notes: '',
        alert_id: '',
        submitted_by: '',
        submitted_on: '',
        custom_reason: ''
      }
    }
  }
}
